import React from "react";

import { trDts } from "@modules/datasheets/utils/i18n";
import FormatManagement from "@common/components/FormatManagement";
import { MessageBox } from "@common/components/MessageBox";

import { DatasheetSaveAsProps, useDatasheetSaveAsController } from "./datasheet-save-as.controller";

import "./datasheet-save-as.styles.scss";

export const DatasheetSaveAs: React.FC<DatasheetSaveAsProps> = (props) => {
  const {
    folders,
    formats,
    isSaveAsLoading,
    handleFormatDelete,
    handleFolderDelete,
    handleFolderCreate,
    getAndSetFormats,
    getAndSetFolders,
    handleSaveAsSubmit,
    isAllowedSaveAsSubmit,
    messageProps,
    closeMessage,
  } = useDatasheetSaveAsController(props);

  return (
    <div className="DatasheetsEditorDatasheetFormatSaveAs">
      <MessageBox hideMessageBox={closeMessage} {...messageProps} />
      <FormatManagement
        mode="save"
        title={trDts("Save As Datasheet Format")}
        formatNameInputLabel={trDts("Name")}
        submitBtnProps={{ text: isSaveAsLoading ? trDts("Saving") : trDts("Save") }}
        isAllowedToSubmit={isAllowedSaveAsSubmit}
        close={props.onClose}
        folders={folders}
        formats={formats}
        getFormats={getAndSetFormats}
        getFolders={getAndSetFolders}
        onSubmit={handleSaveAsSubmit}
        deleteFormatBtnProps={{
          text: trDts("Delete Format"),
        }}
        onFormatDelete={handleFormatDelete}
        onFolderDelete={handleFolderDelete}
        onFolderCreate={handleFolderCreate}
      />
    </div>
  );
};
